import Register from '../../../utils/Register';
import naja from 'naja';

export default class ProductPagination {

	constructor () {
		naja.uiHandler.addEventListener('interaction', (event) => {
			if (event.detail.element.parentElement?.classList.contains('pagination')) {
				event.detail.options.scrollTo = document.querySelector('.product-list');
			}

			if (event.detail.element.classList.contains('js-pagination-load-more')) {
				event.detail.options.appendData = true;
			}
		});

		naja.snippetHandler.addEventListener('beforeUpdate', (event) => {
			const { snippet, content, options } = event.detail;
			if (snippet.id === 'snippet-productList-items' && options.appendData) {
				snippet.insertAdjacentHTML('beforeend', content)
				naja.snippetHandler.dispatchEvent(
					new CustomEvent('afterUpdate', { detail: { snippet, content, options } })
				);
				event.preventDefault();
			}
		});
	}

	static init ($container) {
		if ($container[0].querySelector('.js-product-list-pagination')) {
			new ProductPagination();
		}
	}

}

(new Register()).registerCallback(ProductPagination.init, 'ProductPagination.init');